import { render } from "./icon-vk.vue?vue&type=template&id=063fe196"
import script from "./icon-vk.vue?vue&type=script&lang=js"
export * from "./icon-vk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/icons/icon-vk.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "063fe196"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('063fe196', __exports__)) {
    api.reload('063fe196', __exports__)
  }
  
  module.hot.accept("./icon-vk.vue?vue&type=template&id=063fe196", () => {
    api.rerender('063fe196', render)
  })

}


export default __exports__